import { OptionType } from '@repo/toolkit/types'
import MultiSelectInput, { MultiSelectInputProps } from '@repo/ui/multiselect-input'

import { useFormField } from '../forms/form'

const ControlledMultiSelectInput = <T extends OptionType>(props: MultiSelectInputProps<T>) => {
  const { error } = useFormField()
  return <MultiSelectInput {...props} errorMessage={error ? String(error?.message) : undefined} />
}

export default ControlledMultiSelectInput
